import classnames from 'classnames';
import { observer } from 'mobx-react';
import * as React from 'react';

import { CheckboxMinusIcon, CheckboxOffIcon, CheckboxOnIcon, IconProps } from '../../common/icons';

const styles = require('./check-item.css');

const fonts = require('../../common/fonts.css');

/** Props for the check item */
export interface CheckItemProps {
  /** Additional classes */
  className?: string;
  /** Size of the check item */
  size: IconProps['size'];
  /** Label to show */
  label?: string;
  /** Hint text for the question */
  hintText?: string;
  /** Whether it is selected */
  selected: boolean;
  /** Whether it is indeterminate */
  indeterminate?: boolean;
  /** Selection change handler */
  onChange?(value: boolean): void;
  /** Disabled */
  disabled?: boolean;
  /** Outlined */
  outlined?: boolean;
  /** In a table? */
  inTable?: boolean;
}

/**
 * A Check box and  a label.
 */
@observer
export class CheckItem extends React.Component<CheckItemProps> {
  /** Renders the component */
  render() {
    return (
      <div
        className={classnames(
          this.props.inTable ? styles.tableCell : undefined,
          styles.checkItem,
          this.props.outlined ? styles.outlined : undefined,
          this.props.disabled ? styles.disabled : undefined,
          this.props.className
        )}
        onClick={this.props.disabled ? undefined : this.onToggle}
      >
        {this.props.indeterminate === true ? (
          <CheckboxMinusIcon
            size={this.props.size}
            className={this.props.disabled ? styles.disabled : undefined}
            color={this.props.outlined ? 'black' : undefined}
          />
        ) : this.props.selected ? (
          <CheckboxOnIcon
            size={this.props.size}
            className={this.props.disabled ? styles.disabled : undefined}
            color={'orange'} //{this.props.outlined ? "black" : undefined}
          />
        ) : (
          <CheckboxOffIcon
            size={this.props.size}
            className={this.props.disabled ? styles.disabled : undefined}
            color={this.props.outlined ? 'black' : undefined}
          />
        )}

        {this.props.label && (
          <div
            className={this.props.selected ? classnames(styles.checkItemLabel, styles.selected) : styles.checkItemLabel}
          >
            <div title={this.props.hintText} className={fonts.caption}>
              {this.props.label}
            </div>
          </div>
        )}
      </div>
    );
  }

  /** Toggles the selection */
  onToggle = () => {
    if (this.props.onChange !== undefined) {
      this.props.onChange(!this.props.selected);
    }
  };
}



// WEBPACK FOOTER //
// ./src/ui/widgets/check-item/check-item.tsx